import { TwoColumnLayout } from 'layouts';
import type { Event } from 'models';
import { CommentsWrapperSocialEvent } from 'features/feed';
import { EventDetailDescription } from '../../components';
import { EventChannel } from '../event-channel';
import { EventDetailAttachments } from '../event-detail-attachments';
import { EventDetailInviteesWrapper } from '../event-detail-invitees-wrapper';
import { EventDetailsCard } from '../event-details-card';
import { EventDetailStatusMessage } from './event-detail-status-message';

type P = {
  event: Event;
};

const EventDetailCanceled = ({ event }: P) => {
  const { html, id } = event;
  const medicalGroupName = 'medicalGroupName' in event ? event.medicalGroupName : undefined;

  return (
    <TwoColumnLayout
      left={
        <>
          <EventDetailStatusMessage />
          <EventDetailDescription eventId={id} htmlContent={html} />
          <CommentsWrapperSocialEvent card eventId={id} eventType={event.type} />
        </>
      }
      right={
        <>
          <EventDetailInviteesWrapper event={event} />
          <EventDetailAttachments event={event} />
          <EventChannel event={event} />
          {medicalGroupName ? <EventDetailsCard medicalGroupName={medicalGroupName} /> : null}
        </>
      }
    />
  );
};

export default EventDetailCanceled;
